import {Rule} from 'antd/lib/form';
import dayjs from 'dayjs';

import {LangKeyType} from '../../../../../../../provider/locale/translation/type';

export const OPENING_DATE_FORMAT = 'YYYY-MM-DD';

export function toOpeningDateDayjs(openingDate: string | null | undefined): dayjs.Dayjs | null {
    if (!openingDate) {
        return null;
    }

    const strictDate = dayjs(openingDate, OPENING_DATE_FORMAT, true);

    if (strictDate.isValid()) {
        return strictDate;
    }

    const date = dayjs(openingDate);

    return date.isValid() ? date : null;
}

export function hasOpeningDate(openingDate: string | null | undefined): boolean {
    return toOpeningDateDayjs(openingDate) !== null;
}

export function disablePastOpeningDates(currentDate: dayjs.Dayjs): boolean {
    return currentDate.isBefore(dayjs().add(1, 'day').startOf('day'), 'day');
}

export function getOpeningDateRequiredRule(
    isOpeningSoonEnabled: () => boolean,
    getLocalizedString: (key: LangKeyType) => string
): Rule {
    return {
        validator: (_rule, value: string | null | undefined) => {
            if (!isOpeningSoonEnabled() || hasOpeningDate(value)) {
                return Promise.resolve();
            }

            return Promise.reject(
                new Error(getLocalizedString('COMPANY_FORM__WORKING_TIME__OPENING_SOON__DATE_REQUIRED'))
            );
        },
    };
}
